import { AssetFile } from 'contentful';
import { CTAButton } from '../../../../components/Clickables/Buttons/CTAButton/CTAButton';
import { Heading } from '../../../../components/Heading/Heading';
import { ProPaymentPlans } from '../../../../components/ProPaymentPlans/ProPaymentPlans';
import { Text } from '../../../../components/Text/Text';
import { FREE_TRIAL_DAYS, ProPlanId } from '../../../../constants/premium';
import { trackEvent } from '../../../../helpers/analytics/trackEvent';
import { ICoupon } from '../../../../interfaces/stripe';
import { CMSBannerImage } from '../CMSBannerImage/CMSBannerImage';
import { CMSPartnerLogo } from './CMSPartnerLogo';

export interface IProps {
  headerTitle: string;
  headerText?: string;
  buttonText: string;
  bannerImageDesktop?: AssetFile;
  bannerImageTablet?: AssetFile;
  bannerImageMobile?: AssetFile;
  logoDesktop?: AssetFile;
  logoMobile?: AssetFile;
  currentPage: string;
  coupon?: ICoupon;
  couponIsLoading: boolean;
  userHasBeenPro: boolean;
  proPlanId: ProPlanId;
  onPlanSelect: (proPlanId: ProPlanId) => void;
  submitLink: string;
  onSubmitLinkClick?: () => void;
}

export const CMSPartnerHeader = ({
  headerTitle,
  headerText,
  buttonText,
  bannerImageDesktop,
  bannerImageTablet,
  bannerImageMobile,
  logoDesktop,
  logoMobile,
  currentPage,
  coupon,
  couponIsLoading,
  userHasBeenPro,
  proPlanId,
  onPlanSelect,
  submitLink,
  onSubmitLinkClick,
}: IProps) => {
  return (
    <header data-testid="CMSPartnerHeader">
      <div className="mx-auto flex max-w-(--breakpoint-lg) flex-col sm:grid sm:grid-cols-1 sm:grid-rows-1">
        {bannerImageDesktop && (
          <div className="col-start-1 row-start-1 w-full object-cover">
            <CMSBannerImage
              bannerTitle="Hero banner image"
              bannerDesktop={bannerImageDesktop}
              bannerMobile={bannerImageMobile}
              bannerTablet={bannerImageTablet}
            />
          </div>
        )}

        <div className="sm:col-start-1 sm:row-start-1 sm:grid sm:grid-cols-2 sm:grid-rows-1">
          {logoDesktop && (
            <div className="mx-auto my-6 w-full max-w-[500px] px-10 sm:col-start-2 sm:row-start-1 sm:mt-12 md:mt-20">
              <CMSPartnerLogo
                logoTitle="Fishbrain logo"
                logoMobile={logoMobile}
                logoDesktop={logoDesktop}
              />
            </div>
          )}
          {!couponIsLoading && coupon && (
            <div className="w-col-4 mx-auto flex flex-col sm:col-start-1 sm:row-start-1 sm:mt-16 sm:w-full sm:pl-10 md:mt-24 md:pl-28">
              <Heading
                as="h1"
                variant="md"
                className="sm:text-sea-foam mt-0 text-center whitespace-pre-line sm:text-left"
              >
                {headerTitle}
              </Heading>
              {headerText && (
                <Text variant="md" className="sm:text-sea-foam text-center sm:text-left">
                  {headerText}
                </Text>
              )}

              <CTAButton
                type="pro"
                variant="buttonPro"
                routerPushTo={submitLink}
                className="mx-auto mt-4 sm:ml-0"
                source="partner-header"
              >
                {buttonText || 'Get Pro'}
              </CTAButton>
            </div>
          )}
          {!couponIsLoading && !coupon && (
            <div className="sm:w-col-7 sm:ml-12 md:ml-24">
              <Heading
                as="h1"
                variant="md"
                className="sm:text-sea-foam mx-8 mt-0 text-center whitespace-pre-line sm:mx-0 sm:text-left"
              >
                {`Try Fishbrain Pro 
                ${FREE_TRIAL_DAYS} days for free`}
              </Heading>
              <ProPaymentPlans
                className="px-6"
                coupon={coupon}
                couponIsLoading={couponIsLoading}
                backgroundColour="bg-sea-foam"
                submitLink={submitLink}
                proPlanId={proPlanId}
                onPlanSelect={onPlanSelect}
                userHasBeenPro={userHasBeenPro}
                planCardTitle="Select your plan"
                onSubmitLinkClick={() => {
                  onSubmitLinkClick?.();
                  void trackEvent({
                    name: 'mykiss_cta_button_clicked',
                    properties: {
                      type: 'pro',
                      source: 'partner-header',
                      page: currentPage,
                    },
                  });
                }}
              />
            </div>
          )}
        </div>
      </div>
    </header>
  );
};
